// C5 · رفع Excel + معاينة + field-mapping — per-screen i18n namespace, merged at
// load time by i18n.ts's require.context('./screens'). Full ar/en parity.
module.exports = {
  ar: {
    'employee-import': {
      loading: 'جارٍ التحميل…',
      error: 'حدث خطأ أثناء قراءة الملف',
      title: 'استيراد موظفين (Excel)',
      crumbEmployees: 'الموظفين',
      crumbImport: 'استيراد',
      search: 'بحث سريع',
      cancel: 'إلغاء',
      steps: {
        download: 'تنزيل القالب',
        upload: 'رفع الملف',
        preview: 'معاينة الصفوف والأخطاء',
        confirm: 'تأكيد الاستيراد',
      },
      dropzone: 'اسحب ملف Excel هنا أو اضغط للرفع',
      dropzoneHint: '.xlsx — بحد أقصى 20000 صف',
      reading: 'جارٍ قراءة الملف…',
      templateTitle: 'القالب الرسمي',
      templateFile: 'قالب_موظفين.xlsx',
      templateColumns: 'الأعمدة: الاسم / الرقم القومي / رقم الكارت / الموبايل / email / القسم (اختياري) / رقم البوليصة (اختياري) / الفئة (اختياري)',
      downloadTemplate: 'تحميل القالب',
      templateReady: 'تم تجهيز القالب للتحميل',
      mappingTitle: 'مطابقة الأعمدة',
      mappingHint: 'الأعمدة المكتشفة من الملف مقابل حقول النظام',
      unmapped: 'غير مطابق',
      previewTitle: 'معاينة الملف',
      validCount: '✔ {n} سليم',
      invalidCount: '⚠ {n} أخطاء',
      th: {
        index: '#',
        name: 'الاسم',
        nationalId: 'الرقم القومي',
        memberCode: 'كود العضو',
        relation: 'صلة القرابة',
        cardNumber: 'رقم الكارت',
        mobile: 'الموبايل',
        email: 'البريد',
        password: 'كلمة مرور مؤقتة',
        dept: 'القسم',
        status: 'الحالة',
      },
      relations: {
        principal: 'الموظف',
        spouse: 'زوج/زوجة',
        child: 'ابن/ابنة',
        other: 'أخرى',
      },
      templateInstructionsTitle: 'تعليمات تعبئة القالب',
      templateInstructions: [
        'الاسم والرقم القومي إجباريان لكل صف.',
        'الرقم القومي يجب أن يكون 14 رقماً بالضبط (بدون مسافات أو رموز).',
        'القسم (اختياري): اسم قسم موجود مسبقاً في الشركة.',
        'رقم البوليصة (اختياري): رقم بوليصة الشركة لربط الموظف بها.',
        'الفئة (اختياري): اسم فئة من شجرة العقد (بالعربي أو الإنجليزي) — الفئة غير المعروفة يُستورد الموظف بدونها.',
        'الحد الأقصى 20000 صف، وصيغة الملف .xlsx فقط.',
      ],
      nationalIdRule: 'الرقم القومي = 14 رقماً',
      th_policy: 'رقم البوليصة',
      th_errors: 'الأخطاء',
      rowErrors: {
        NO_NAME: 'الاسم ناقص',
        NO_IDENTITY: 'لا يوجد معرِّف (رقم قومي أو كود عضو)',
        NAME_REQUIRED: 'الاسم ناقص',
        NATIONAL_ID_REQUIRED: 'الرقم القومي ناقص',
        NATIONAL_ID_INVALID: 'الرقم القومي يجب أن يكون 14 رقماً',
        NATIONAL_ID_DUPLICATE: 'الرقم القومي مكرر',
        DUPLICATE: 'الموظف موجود مسبقاً',
        DEPARTMENT_NOT_FOUND: 'القسم غير موجود في الشركة',
        POLICY_NOT_FOUND: 'رقم البوليصة غير موجود',
        POLICY_NUMBER_UNKNOWN: 'رقم البوليصة غير معروف',
        TIER_NOT_FOUND: 'الفئة غير موجودة في شجرة العقد',
        EMAIL_INVALID: 'البريد الإلكتروني غير صالح',
        UNKNOWN: 'خطأ في بيانات الصف',
      },
      apiErrors: {
        INVALID_IMPORT_FILE: 'الملف ليس ملف Excel (.xlsx) صالحاً',
        IMPORT_TOO_MANY_ROWS: 'الملف يتجاوز الحد الأقصى (20000 صف)',
        VALIDATION_ERROR: 'بيانات الملف غير صالحة',
        FORBIDDEN: 'ليس لديك صلاحية استيراد الموظفين',
        UNSUPPORTED_MEDIA_TYPE: 'صيغة الملف غير مدعومة',
        PAYLOAD_TOO_LARGE: 'حجم الملف كبير جدًا — الحد الأقصى 10 ميجابايت',
        generic: 'حدث خطأ أثناء قراءة الملف',
      },
      invalidListTitle: 'الصفوف التي بها أخطاء',
      warningsTitle: 'تم استيراد هؤلاء الموظفين لكن بدون قسم/بوليصة',
      skippedTitle: 'صفوف لم تُستورد',
      skippedRow: 'الصف {row}: {reason}',
      showingFirst: 'تعرض المعاينة أول {n} صفوف فقط — العدّادات أعلاه تشمل الملف كاملاً.',
      rowValid: 'سليم',
      missing: '— ناقص —',
      selectedFile: 'الملف المختار: {name}',
      errors: {
        nationalIdMissing: '⚠ رقم قومي ناقص',
        nationalIdShort: '⚠ رقم قومي أقل من 14',
        mobileMissing: '⚠ الموبايل ناقص',
      },
      fileErrors: {
        required: '⚠ يجب اختيار ملف',
        type: '⚠ صيغة الملف غير مدعومة — يُسمح فقط بملفات Excel (.xlsx)',
        size: '⚠ حجم الملف كبير جدًا — الحد الأقصى 10 ميجابايت',
      },
      fields: {
        fullName: 'حقل الاسم',
        nameFirst: 'الاسم الأول',
        nameMiddle: 'الاسم الأوسط',
        nameFamily: 'اسم العائلة',
        nameLast: 'اسم العائلة/الأخير',
        nationalId: 'الرقم القومي',
        memberCode: 'كود العضو',
        staffCode: 'الرقم الوظيفي',
        relation: 'صلة القرابة',
        principalCode: 'كود المعيل',
        gender: 'النوع',
        maritalStatus: 'الحالة الاجتماعية',
        birthDate: 'تاريخ الميلاد',
        coverageStart: 'بداية التغطية',
        coverageEnd: 'نهاية التغطية',
        nationality: 'الجنسية',
        jobTitle: 'المسمى الوظيفي',
        deptId: 'القسم',
        department: 'القسم',
        policyNumber: 'رقم البوليصة',
        tier: 'الفئة',
        cardNumber: 'رقم الكارت',
        mobile: 'الموبايل',
        email: 'البريد',
      },
      footerHint: 'سيتم حفظ {valid} صف سليم — الصفوف الـ{invalid} الخاطئة تحتاج إلى تصحيح أولاً',
      fixErrors: '✏️ تصحيح الأخطاء',
      confirmImport: '✔ تأكيد استيراد الـ{valid}',
      confirming: 'جارٍ الاستيراد…',
      empty: 'لا توجد صفوف للمعاينة',
      successTitle: 'تم الاستيراد',
      successMsg: 'تم إضافة {created} موظف بنجاح.',
      successUpdated: 'وتم تحديث {updated} موظف موجود مسبقاً.',
      credentialsTitle: 'بيانات الدخول المؤقتة',
      credentialsHint: 'تظهر مرة واحدة فقط — انسخها الآن وسلّمها للموظفين.',
      applyMapping: '↻ طبّق المطابقة',
      remapping: 'جارٍ إعادة المطابقة…',
      mappingHintEditable: 'عدّل مطابقة أي عمود ثم اضغط «طبّق المطابقة» لإعادة المعاينة.',
      fileWarningsTitle: 'تنبيهات على الملف',
      fileWarnings: {
        LOOKS_LIKE_UTILIZATION: 'الملف ده شكله تقرير استهلاك/مطالبات (صف لكل زيارة) مش شيت موظفين — راجعه قبل التأكيد.',
        MULTIPLE_SHEETS: 'الملف فيه أكتر من sheet — اتأكد إن النظام اختار الصح.',
      },
      reimport: '↻ استيراد ملف جديد',
    },
  },
  en: {
    'employee-import': {
      loading: 'Loading…',
      error: 'Something went wrong reading the file',
      title: 'Import employees (Excel)',
      crumbEmployees: 'Employees',
      crumbImport: 'Import',
      search: 'Quick search',
      cancel: 'Cancel',
      steps: {
        download: 'Download template',
        upload: 'Upload file',
        preview: 'Preview rows & errors',
        confirm: 'Confirm import',
      },
      dropzone: 'Drag an Excel file here or click to upload',
      dropzoneHint: '.xlsx — up to 20000 rows',
      reading: 'Reading file…',
      templateTitle: 'Official template',
      templateFile: 'employees_template.xlsx',
      templateColumns: 'Columns: Name / National ID / Card number / Mobile / Email / Department (optional) / Policy number (optional) / Tier (optional)',
      downloadTemplate: 'Download template',
      templateReady: 'Template ready to download',
      mappingTitle: 'Column mapping',
      mappingHint: 'Columns detected in the file vs. system fields',
      unmapped: 'Unmapped',
      previewTitle: 'File preview',
      validCount: '✔ {n} valid',
      invalidCount: '⚠ {n} errors',
      th: {
        index: '#',
        name: 'Name',
        nationalId: 'National ID',
        memberCode: 'Member code',
        relation: 'Relation',
        cardNumber: 'Card number',
        mobile: 'Mobile',
        email: 'Email',
        password: 'Temporary password',
        dept: 'Department',
        status: 'Status',
      },
      relations: {
        principal: 'Employee',
        spouse: 'Spouse',
        child: 'Child',
        other: 'Other',
      },
      templateInstructionsTitle: 'Template instructions',
      templateInstructions: [
        'Name and National ID are required on every row.',
        'National ID must be exactly 14 digits (no spaces or symbols).',
        'Department (optional): the name of an existing company department.',
        'Policy number (optional): the company policy number to link the employee to.',
        'Tier (optional): a contract-tree tier name (Arabic or English) — an unknown tier is imported without one.',
        'Maximum 20000 rows, .xlsx files only.',
      ],
      nationalIdRule: 'National ID = 14 digits',
      th_policy: 'Policy number',
      th_errors: 'Errors',
      rowErrors: {
        NO_NAME: 'Name is missing',
        NO_IDENTITY: 'No identifier (national ID or member code)',
        NAME_REQUIRED: 'Name is missing',
        NATIONAL_ID_REQUIRED: 'National ID is missing',
        NATIONAL_ID_INVALID: 'National ID must be 14 digits',
        NATIONAL_ID_DUPLICATE: 'Duplicate National ID',
        DUPLICATE: 'Employee already exists',
        DEPARTMENT_NOT_FOUND: 'Department not found in the company',
        POLICY_NOT_FOUND: 'Policy number not found',
        POLICY_NUMBER_UNKNOWN: 'Unknown policy number',
        TIER_NOT_FOUND: 'Tier not found in the contract tree',
        EMAIL_INVALID: 'Invalid email address',
        UNKNOWN: 'Row data error',
      },
      apiErrors: {
        INVALID_IMPORT_FILE: 'The file is not a valid Excel (.xlsx) workbook',
        IMPORT_TOO_MANY_ROWS: 'The file exceeds the 20000-row limit',
        VALIDATION_ERROR: 'The file data is invalid',
        FORBIDDEN: 'You do not have permission to import employees',
        UNSUPPORTED_MEDIA_TYPE: 'Unsupported file format',
        PAYLOAD_TOO_LARGE: 'File is too large — the maximum is 10MB',
        generic: 'Something went wrong reading the file',
      },
      invalidListTitle: 'Rows with errors',
      warningsTitle: 'Imported, but left without a department/policy',
      skippedTitle: 'Rows not imported',
      skippedRow: 'Row {row}: {reason}',
      showingFirst: 'The preview shows only the first {n} rows — the counters above cover the whole file.',
      rowValid: 'Valid',
      missing: '— missing —',
      selectedFile: 'Selected file: {name}',
      errors: {
        nationalIdMissing: '⚠ National ID missing',
        nationalIdShort: '⚠ National ID under 14',
        mobileMissing: '⚠ Mobile missing',
      },
      fileErrors: {
        required: '⚠ Please choose a file',
        type: '⚠ Unsupported file format — only Excel files (.xlsx) are allowed',
        size: '⚠ File is too large — the maximum is 10MB',
      },
      fields: {
        fullName: 'Name field',
        nameFirst: 'First name',
        nameMiddle: 'Middle name',
        nameFamily: 'Family name',
        nameLast: 'Last name',
        nationalId: 'National ID',
        memberCode: 'Member code',
        staffCode: 'Staff code',
        relation: 'Relation',
        principalCode: 'Principal code',
        gender: 'Gender',
        maritalStatus: 'Marital status',
        birthDate: 'Date of birth',
        coverageStart: 'Coverage start',
        coverageEnd: 'Coverage end',
        nationality: 'Nationality',
        jobTitle: 'Job title',
        deptId: 'Department',
        department: 'Department',
        policyNumber: 'Policy number',
        tier: 'Tier',
        cardNumber: 'Card number',
        mobile: 'Mobile',
        email: 'Email',
      },
      footerHint: '{valid} valid rows will be saved — the {invalid} broken rows need fixing first',
      fixErrors: '✏️ Fix errors',
      confirmImport: '✔ Confirm import of {valid}',
      confirming: 'Importing…',
      empty: 'No rows to preview',
      successTitle: 'Import complete',
      successMsg: '{created} employees added successfully.',
      successUpdated: 'and {updated} existing employees were updated.',
      credentialsTitle: 'Temporary login credentials',
      credentialsHint: 'Shown once only — copy them now and hand them to the employees.',
      applyMapping: '↻ Apply mapping',
      remapping: 'Re-mapping…',
      mappingHintEditable: 'Change any column mapping, then click “Apply mapping” to re-preview.',
      fileWarningsTitle: 'File warnings',
      fileWarnings: {
        LOOKS_LIKE_UTILIZATION: 'This looks like a utilization/claims report (one row per visit), not an employee roster — review before confirming.',
        MULTIPLE_SHEETS: 'The file has multiple sheets — make sure the right one was picked.',
      },
      reimport: '↻ Import another file',
    },
  },
};
